export default __webpack_public_path__ + "static/media/incidentio.a1780f33.svg";